var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorState',{attrs:{"insides":['notfound_item', 'notfound_back'],"subtitle":"Essa tela ou funcionalidade não foi encontrada :/","buttons":[{
              text: 'Voltar para home',
              click: function () { return _vm.goToPage('Home'); },
            }]}})}
var staticRenderFns = []

export { render, staticRenderFns }